import { Loading } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { routes } from "routing";
import { ItineraryHeaderPane } from "./itinerary-header-pane";
import { usePaneSide } from "../layout/panes/pane-context";
import { isIosNativeNavigation } from "../nativeNavigation/platform";
import { useShallow } from "zustand/react/shallow";
import ItineraryCarousel, { useIsHeaderVisible } from "../../home/components/carousel/ItineraryCarousel";
import { NoOrg } from "../../home/components/noOrg";
import { OrgIsBeeingMade } from "../../home/components/orgIsBeeingMade";
import { useBoundStore } from "../../state/bound.store";
import { HEADER_HEIGHT } from "../../state/scrollState/scrollContext";
import { useTopInset } from "../../state/windowState/window.store";
import { useIsTwoPane } from "../layout/screen-layout";
import { useGuestStore } from "../guest/guest.store";
import { HomeScrollAwayContent } from "./home-scroll-away";

export const HomeRoutes = () => {
  const topInset = useTopInset();
  const { profile } = useBoundStore(
    useShallow((s) => {
      return { profile: s.profile };
    }),
  );
  const isGuestMode = useGuestStore(useShallow((s) => s.isGuestMode));
  const isHeaderVisible = useIsHeaderVisible();
  // In the two-pane layout the header and the page it scrolls over are the leading pane's.
  const twoPane = useIsTwoPane();
  const paneSide = usePaneSide();
  const { pathname } = useLocation();

  if (!isGuestMode) {
    if (!profile)
      return (
        <Stack direction="row" sx={{
          justifyContent: "center"
        }}>
          <Loading id="Profile-loading" />
        </Stack>
      );

    if (profile.organisations?.length === 0) return <NoOrg />;

    if (profile.organisations?.length === 1 && profile.organisations?.[0]?.status === "creating")
      return <OrgIsBeeingMade />;
  }

  // Under iOS native navigation the Chat or Team root is the leading split column itself, which
  // PaneShell never wraps, so it is headed here as PaneShell heads it on the web. Home heads its
  // own column (see HomePage).
  if (twoPane && isIosNativeNavigation() && paneSide === "leading" && pathname !== routes.home.path) {
    return (
      <ItineraryHeaderPane>
        <Outlet />
      </ItineraryHeaderPane>
    );
  }

  // The carousel header is a fixed overlay (see CarouselContainer), not part of
  // document flow, so its height doesn't push this content down. Add the offset here.
  if (twoPane) return <Outlet />;

  const headerOffset = isHeaderVisible ? HEADER_HEIGHT + topInset : 0;

  return (
    <>
      <ItineraryCarousel />
      <HomeScrollAwayContent headerOffset={headerOffset}>
        <Outlet />
      </HomeScrollAwayContent>
    </>
  );
};
